import React, {useState} from "react"
import {Form} from "react-bootstrap";
import {Controller, useForm} from "react-hook-form";
import {EmailValidation, maxLength, Required} from "../../../utils/patterns";
import TextInput from "../../../components/common/input-field/TextInput";
import ThemeButton from "../../../components/common/theme-button/ThemeButton";
import {useNavigate} from "react-router";
import ThemeModal from "../../../components/common/modals/theme-modal/ThemeModal";
import OtpVerification from "./otp-verification/OtpVerification";
import Heading from "../../../components/dashboard/heading-component/Heading";
import {UserAuthService} from "../../../services/user-auth-api.service";
import {notification} from "antd";
import {RoundedCheck} from "../../../../assets/icons/defaultIcons";
import {useUser} from "../../../providers/UserContext";


export default function ForgotPassword() {
    const [openOtp, setOpenOtp] = useState();
    const [loader, setLoader] = useState();
    const {otpVerified, setOtpVerified} = useUser()
    const {
        handleSubmit,
        reset,
        setValue,
        formState: {errors},
        control,
        clearErrors
    } = useForm({
        mode: 'onChange',
    })
    const navigate = useNavigate()

    const onSubmit = async (data) => {
        setLoader(true)
        const result = await UserAuthService.ForgetPasswordApi(data.email)
        if (result?.data?.data?.status) {
            notification.success({
                message: "Success",
                description: `${result?.data?.data?.message}`,
                placement: "topRight",
                icon: <RoundedCheck/>,
                duration: 2,
            });
            setOtpVerified(false)
            navigate('/otp-verfication-password', { state: { email: data.email } });
        }
        setLoader(false)
    }

    return(
        <div className={'login'}>
            <Heading back={true} heading={'Forgot Password?'}/>
            <h5>Enter the email we'll send verification code to reset your password.</h5>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <div className={'dfields'}>
                    <Controller
                        name="email"
                        defaultValue={''}
                        control={control}
                        rules={{required: Required, pattern:EmailValidation, maxLength: maxLength(100)}}
                        render={({field: {name, ...field}}) => (
                            <TextInput
                                placeholder={'Enter your email here'}
                                label={'Email Address'}
                                type={'email'}
                                field={field}
                                errors={errors.email}
                                className={'required'}
                            />
                        )}
                    />
                </div>

                <div className={'dfields mt-4'}>
                    <ThemeButton
                        text={'Submit'}
                        className={'btn-light-lg'}
                        type={'submit'}
                        loader={loader}
                    />
                </div>

            </Form>
            <ThemeModal
                children={<OtpVerification/>}
                show={openOtp}
                close={setOpenOtp}
                modalHeading={'Verify your account'}
                btnText={'Next'}
            />
        </div>
    )
}